
<template v-if="loading">
  <div class="lds-dual-ring"
       :class="{'hidden': !loading}"
  >
    <div /><div /><div /><div /><div /><div /><div /><div />
  </div>

</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class TheMiniLoader extends Vue {
  @Prop()
  loading!: boolean
}
</script>

<style lang="scss" scoped>
.lds-dual-ring {
  position: absolute;
  display: inline-block;
  width: 16px;
  height: 10px;
}

.lds-dual-ring::after {
  content: " ";
  display: block;
  width: 10px;
  height: 10px;
  margin: 2px;
  border-radius: 80%;
  border: 1px solid $primary;
  border-color: $primary transparent $primary transparent;
  animation: lds-dual-ring 0.5s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.hidden {
  display: none;
}
</style>
